import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { NugetType, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import cloneDeep from 'lodash-es/cloneDeep';
import { of, } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var mappings = MapperService.settingsMappings;
export var DeploymentAuthenticationType;
(function (DeploymentAuthenticationType) {
    DeploymentAuthenticationType["apiKey"] = "apiKey";
    DeploymentAuthenticationType["basicAuth"] = "basic";
    DeploymentAuthenticationType["secure"] = "secure";
})(DeploymentAuthenticationType || (DeploymentAuthenticationType = {}));
var SettingService = /** @class */ (function (_super) {
    tslib_1.__extends(SettingService, _super);
    function SettingService(http) {
        var _this = _super.call(this, http, MapperService.settingMap) || this;
        _this._endpoint = '/odata/Settings';
        return _this;
    }
    SettingService.prototype.getConnectionString = function () {
        return (this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetConnectionString"))
            .pipe(map(function (result) { return result.value; }));
    };
    SettingService.prototype.getTimezones = function () {
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetTimezones")
            .pipe(map(function (result) {
            return result.Items;
        }));
    };
    SettingService.prototype.getServerSettings = function () {
        return this.get().pipe(map(function (response) {
            var getProp = function (prop) {
                var setting = response.data.find(function (s) { return s.id === prop; });
                return setting ? setting.value : null;
            };
            var settingsAuthenticationTypeMapper = function (nugetType) {
                switch (getProp(mappings.deployment[nugetType].authenticationType).toLowerCase()) {
                    case 'apikey':
                        return DeploymentAuthenticationType.apiKey;
                    case 'basic':
                        return DeploymentAuthenticationType.basicAuth;
                    case 'secure':
                        return DeploymentAuthenticationType.secure;
                }
                throw new Error('settingsAuthenticationTypeMapper -> unknown type');
            };
            var passwordComplexity = MapperService.passwordComplexityMapper(getProp(mappings.security.passwordComplexity));
            var isSignalRTransporterEnabled = function (reverseIndex) {
                var signalRTransport = Number(getProp(mappings.scalability.signalRTransport));
                return !!Number(signalRTransport
                    .toString(2)
                    .padStart(3, '0')
                    .slice(reverseIndex * -1)
                    .slice(0, 1));
            };
            return {
                mail: {
                    alertsEmailEnabled: getProp(mappings.mail.alertsEmailEnabled) === 'true',
                    smtpHost: getProp(mappings.mail.smtpHost),
                    smtpPort: getProp(mappings.mail.smtpPort),
                    smtpDomain: getProp(mappings.mail.smtpDomain),
                    smtpUsername: getProp(mappings.mail.smtpUsername),
                    smtpPassword: getProp(mappings.mail.smtpPassword),
                    smtpUseDefaultCredentials: getProp(mappings.mail.smtpUseDefaultCredentials) === 'true',
                    smtpEnableSsl: getProp(mappings.mail.smtpEnableSsl) === 'true',
                    defaultFromAddress: getProp(mappings.mail.defaultFromAddress),
                    defaultFromDisplayName: getProp(mappings.mail.defaultFromDisplayName),
                },
                general: {
                    timezone: getProp(mappings.general.timezone),
                    language: getProp(mappings.general.language),
                    isModernFolderSystemEnabled: getProp(mappings.general.isModernFolderSystemEnabled) === 'true',
                },
                security: {
                    passwordComplexity: cloneDeep(passwordComplexity),
                    password: {
                        defaultExpirationDays: parseInt(getProp(mappings.security.password.defaultExpirationDays), 10),
                        previousUseLimit: parseInt(getProp(mappings.security.password.previousUseLimit), 10),
                        shouldChangePasswordAfterFirstLogin: getProp(mappings.security.password.shouldChangePasswordAfterFirstLogin) === 'true',
                    },
                    lockout: {
                        isEnabled: getProp(mappings.security.lockout.isEnabled) === 'true',
                        maxAccessAttempts: parseInt(getProp(mappings.security.lockout.maxAccessAttempts), 10),
                        defaultAccountLockoutSeconds: parseInt(getProp(mappings.security.lockout.defaultAccountLockoutSeconds), 10),
                    },
                    robot: {
                        runDisconnected: parseInt(getProp(mappings.security.robot.runDisconnected), 0),
                    },
                },
                scalability: {
                    signalR: {
                        enabled: getProp(mappings.scalability.signalREnabled) === 'true',
                        transportProtocol: {
                            webSocketTransport: isSignalRTransporterEnabled(1),
                            serverSentEventsTransport: isSignalRTransporterEnabled(2),
                            longPollingTransport: isSignalRTransporterEnabled(3),
                        },
                    },
                },
                deployment: {
                    packages: {
                        isInternalDeployment: getProp(mappings.deployment.packages.isInternalDeployment) === 'true',
                        externalDeploymentUrl: getProp(mappings.deployment.packages.deploymentUrl),
                        selectedAuthenticationType: settingsAuthenticationTypeMapper(NugetType.Packages),
                        apiKey: getProp(mappings.deployment.packages.apiKey),
                        basicAuthUsername: getProp(mappings.deployment.packages.basicAuthUsername),
                        basicAuthPassword: getProp(mappings.deployment.packages.basicAuthPassword),
                    },
                    libraries: {
                        useSharedFeed: getProp(mappings.deployment.libraries.useSharedFeed) === 'true',
                        // allowTenantPublish setting is available only for host
                        allowTenantPublish: getProp(mappings.deployment.libraries.allowTenantPublish) == null ?
                            null :
                            getProp(mappings.deployment.libraries.allowTenantPublish) === 'true',
                        isInternalDeployment: getProp(mappings.deployment.libraries.isInternalDeployment) === 'true',
                        externalDeploymentUrl: getProp(mappings.deployment.libraries.deploymentUrl),
                        selectedAuthenticationType: settingsAuthenticationTypeMapper(NugetType.Libraries),
                        apiKey: getProp(mappings.deployment.libraries.apiKey),
                    },
                },
                application: {
                    isTenantRegistrationEnabled: getProp(mappings.application.isTenantRegistrationEnabled) === 'true',
                    termsAndConditionsRegisterUrl: getProp(mappings.application.termsAndConditionsRegisterUrl),
                    customTitle: getProp(mappings.application.customTitle),
                },
            };
        }));
    };
    SettingService.prototype.updateSettingsBulk = function (settings, category) {
        var _a;
        var settingsArray = [];
        if (category['General']) {
            settingsArray.push({
                Name: mappings.general.timezone,
                Value: settings.general.timezone,
            }, {
                Name: mappings.general.language,
                Value: settings.general.language,
            }, {
                Name: mappings.general.isModernFolderSystemEnabled,
                Value: settings.general.isModernFolderSystemEnabled.toString(),
            });
        }
        if (category['Mail']) {
            settingsArray.push({
                Name: mappings.mail.alertsEmailEnabled,
                Value: settings.mail.alertsEmailEnabled.toString(),
            }, {
                Name: mappings.mail.smtpHost,
                Value: settings.mail.smtpHost.trim(),
            }, {
                Name: mappings.mail.smtpPort,
                Value: settings.mail.smtpPort || '',
            }, {
                Name: mappings.mail.smtpDomain,
                Value: settings.mail.smtpDomain.trim(),
            }, {
                Name: mappings.mail.smtpUsername,
                Value: settings.mail.smtpUsername.trim(),
            }, {
                Name: mappings.mail.smtpPassword,
                Value: settings.mail.smtpPassword,
            }, {
                Name: mappings.mail.smtpUseDefaultCredentials,
                Value: settings.mail.smtpUseDefaultCredentials.toString(),
            }, {
                Name: mappings.mail.smtpEnableSsl,
                Value: settings.mail.smtpEnableSsl.toString(),
            }, {
                Name: mappings.mail.defaultFromAddress,
                Value: settings.mail.defaultFromAddress,
            }, {
                Name: mappings.mail.defaultFromDisplayName,
                Value: settings.mail.defaultFromDisplayName.trim(),
            });
        }
        if (category['Security']) {
            var passwordComplexity = JSON.stringify((_a = {},
                _a[mappings.security.complexity.hasDigits] = settings.security.passwordComplexity.hasDigits,
                _a[mappings.security.complexity.hasLowerCase] = settings.security.passwordComplexity.hasLowerCase,
                _a[mappings.security.complexity.hasSpecialCharacter] = settings.security.passwordComplexity.hasSpecialCharacter,
                _a[mappings.security.complexity.hasUpperCase] = settings.security.passwordComplexity.hasUpperCase,
                _a[mappings.security.complexity.length] = settings.security.passwordComplexity.length,
                _a));
            settingsArray.push({
                Name: mappings.security.passwordComplexity,
                Value: passwordComplexity,
            }, {
                Name: mappings.security.password.defaultExpirationDays,
                Value: settings.security.password.defaultExpirationDays.toString(),
            }, {
                Name: mappings.security.password.previousUseLimit,
                Value: settings.security.password.previousUseLimit.toString(),
            }, {
                Name: mappings.security.password.shouldChangePasswordAfterFirstLogin,
                Value: settings.security.password.shouldChangePasswordAfterFirstLogin.toString(),
            }, {
                Name: mappings.security.lockout.isEnabled,
                Value: settings.security.lockout.isEnabled.toString(),
            }, {
                Name: mappings.security.lockout.defaultAccountLockoutSeconds,
                Value: settings.security.lockout.defaultAccountLockoutSeconds.toString(),
            }, {
                Name: mappings.security.lockout.maxAccessAttempts,
                Value: settings.security.lockout.maxAccessAttempts.toString(),
            }, {
                Name: mappings.security.robot.runDisconnected,
                Value: settings.security.robot.runDisconnected.toString(),
            });
        }
        if (category['Scalability']) {
            settingsArray.push({
                Name: mappings.scalability.signalREnabled,
                Value: settings.scalability.signalR.enabled.toString(),
            }, {
                Name: mappings.scalability.signalRTransport,
                Value: [
                    settings.scalability.signalR.transportProtocol.webSocketTransport,
                    settings.scalability.signalR.transportProtocol.serverSentEventsTransport,
                    settings.scalability.signalR.transportProtocol.longPollingTransport,
                ]
                    .reduce(function (prev, curr, index) {
                    return prev + Number(curr) * Math.pow(2, index);
                }, 0)
                    .toString(),
            });
        }
        if (category['Deployment']) {
            settingsArray.push.apply(settingsArray, [{
                    Name: mappings.deployment.packages.isInternalDeployment,
                    Value: settings.deployment.packages.isInternalDeployment.toString(),
                },
                {
                    Name: mappings.deployment.packages.deploymentUrl,
                    Value: settings.deployment.packages.externalDeploymentUrl || '',
                },
                {
                    Name: mappings.deployment.packages.authenticationType,
                    Value: settings.deployment.packages.selectedAuthenticationType,
                },
                {
                    Name: mappings.deployment.packages.apiKey,
                    Value: (settings.deployment.packages.apiKey || '').trim(),
                },
                {
                    Name: mappings.deployment.packages.basicAuthUsername,
                    Value: (settings.deployment.packages.basicAuthUsername || '').trim(),
                },
                {
                    Name: mappings.deployment.packages.basicAuthPassword,
                    Value: (settings.deployment.packages.basicAuthPassword || '').trim(),
                },
                {
                    Name: mappings.deployment.libraries.useSharedFeed,
                    Value: settings.deployment.libraries.useSharedFeed.toString(),
                }].concat((settings.deployment.libraries.allowTenantPublish != null ? [{
                    Name: mappings.deployment.libraries.allowTenantPublish,
                    Value: settings.deployment.libraries.allowTenantPublish.toString(),
                }] : []), [{
                    Name: mappings.deployment.libraries.isInternalDeployment,
                    Value: settings.deployment.libraries.isInternalDeployment.toString(),
                },
                {
                    Name: mappings.deployment.libraries.deploymentUrl,
                    Value: settings.deployment.libraries.externalDeploymentUrl || '',
                },
                {
                    Name: mappings.deployment.libraries.authenticationType,
                    Value: settings.deployment.libraries.selectedAuthenticationType,
                },
                {
                    Name: mappings.deployment.libraries.apiKey,
                    Value: (settings.deployment.libraries.apiKey || '').trim(),
                }]));
        }
        if (category['Application']) {
            settingsArray.push({
                Name: mappings.application.isTenantRegistrationEnabled,
                Value: settings.application.isTenantRegistrationEnabled.toString(),
            }, {
                Name: mappings.application.termsAndConditionsRegisterUrl,
                Value: settings.application.termsAndConditionsRegisterUrl,
            }, {
                Name: mappings.application.customTitle,
                Value: settings.application.customTitle,
            });
        }
        if (!settingsArray.length) {
            return of({});
        }
        var payload = JSON.stringify({ settings: settingsArray });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.UpdateBulk", payload);
    };
    SettingService.prototype.getExecutionSettingsConfiguration = function (scope) {
        var _this = this;
        if (scope === void 0) { scope = 0 /* Global */; }
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetExecutionSettingsConfiguration(scope=" + scope + ")")
            .pipe(map(function (result) { return _this._mapData(result, MapperService.executionSettingsMap); }));
    };
    SettingService.prototype.getCalendar = function () {
        var _this = this;
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetCalendar()";
        return this._http
            .get(endpoint)
            .pipe(map(function (response) { return _this._mapData(response, MapperService.excludedCalendarMapper); }));
    };
    SettingService.prototype.updateCalendar = function (calendar) {
        var endpoint = this._endpoint + "/UiPath.Server.Configuration.OData.SetCalendar";
        return this._http.post(endpoint, this._toPoco(calendar, MapperService.excludedCalendarMapper));
    };
    SettingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingService_Factory() { return new SettingService(i0.ɵɵinject(i1.HttpClient)); }, token: SettingService, providedIn: "root" });
    return SettingService;
}(ODataService));
export { SettingService };
